/*eslint-disable */
import axios from 'axios'
import getConfig from 'next/config'
import { serviceOptions } from '@/shared/services/admin'
import { serviceOptionsUser } from '@/shared/services/user'
import { serviceOptionsVoical } from '@/shared/services/voicecall'
import { serviceOptionsReportCall } from '@/shared/services/reportCallService'

export interface IRequestOptions {
  headers?: any
  baseURL?: string
  responseType?: string
}

export interface IRequestConfig {
  method?: any
  headers?: any
  url?: any
  data?: any
  params?: any
}

const instance = axios.create({
  // baseURL: getConfig().publicRuntimeConfig.apiAdminBasePath,
  baseURL: '/api',
  timeout: 100000,
  withCredentials: false
})

const UNAUTHORIZED = 401
instance.interceptors.response.use(
  (response) => response,
  (error) => {
    const { status } = error.response
    if (status === UNAUTHORIZED) {
      const originUrl = window.location.origin
      let urlLogout = `${getConfig().publicRuntimeConfig.apiAdminBasePath}logout?redirect_url=${originUrl}/login`
      window.location.href = urlLogout
    }
    return Promise.reject(error)
  }
)

const instanceUser = axios.create({
  // baseURL: getConfig().publicRuntimeConfig.apiBasePath,
  baseURL: '/api',
  timeout: 100000,
  withCredentials: false
})

const instanceVoiceCall = axios.create({
  baseURL: getConfig().publicRuntimeConfig.apiBasePath,
  // baseURL: '/api',
  timeout: 100000,
  withCredentials: false
})

const instanceReportCall = axios.create({
  baseURL: getConfig().publicRuntimeConfig.apiBasePath,
  // baseURL: '/api',
  timeout: 100000,
  withCredentials: false
})


serviceOptions.axios = instance
serviceOptionsUser.axios = instanceUser
serviceOptionsVoical.axios = instanceVoiceCall
serviceOptionsReportCall.axios = instanceReportCall

/**
 * create socket instance
 */

export * from './admin'
export * from './user'
export * from './voicecall'
export * from './reportCallService'
